import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  searchBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  searchInputDescription: {
    fontSize: '1.4rem',
  },
  searchInput: {
    width: '100%',
    alignSelf: 'end',
  },
  filterList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    maxHeight: '15rem',
    overflowY: 'auto',
    margin: 0,
    border: `0.1rem solid ${colors.neutral[200]}`,
    padding: '1rem',
    borderRadius: '0.4rem',
    width: '100%',
    boxSizing: 'border-box',
  },
  filterItem: {
    fontSize: '1.4rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
    lineHeight: '2.4rem',
    cursor: 'pointer',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
